var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPopularGames = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9372_70126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49873 0.424988C4.03829 0.424988 0.424805 4.04063 0.424805 8.49891C0.424805 12.9593 4.03829 16.575 8.49873 16.575C12.9592 16.575 16.5748 12.9593 16.5748 8.49891C16.5748 4.04063 12.9592 0.424988 8.49873 0.424988ZM13.2687 7.31878L11.1836 9.3394C11.1406 9.3824 11.1191 9.44688 11.1191 9.51138L11.592 12.3274C11.635 12.6068 11.3341 12.8218 11.0761 12.6928L8.53957 11.3385C8.47507 11.317 8.41059 11.317 8.3461 11.3385L5.85256 12.6713C5.59461 12.8003 5.29366 12.5853 5.33665 12.3059L5.83106 9.44688C5.85256 9.3824 5.83106 9.31791 5.76657 9.27492L3.72445 7.29728C3.50949 7.10382 3.63846 6.73838 3.91792 6.69539L6.77689 6.28697C6.84138 6.28697 6.90586 6.24398 6.92737 6.17949L8.19563 3.59996C8.32461 3.34201 8.69003 3.34201 8.81902 3.59996L10.1088 6.20098C10.1303 6.26547 10.1948 6.30846 10.2593 6.30846L13.0752 6.71689C13.3762 6.75987 13.4837 7.10382 13.2687 7.31878Z",
    fill: "#CCD6F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9372_70126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPopularGames);
export default ForwardRef;